import { getMapmakerStaticUrl } from "@mapmaker/core";

export function getFontUrl(fontName: string): string {
  return getMapmakerStaticUrl(`svg/fonts/${fontName}`);
}
